module.exports = __webpack_public_path__ + "static/sam-ac9af6626e9e416275471213277e953f.jpg";